export default "__VITE_ASSET__BEBkUYnD__"